import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class Token extends BaseModel {
    @Expose()
    type = "";
    @Expose()
    value = "";
    @Expose()
    refreshToken = "";
    @Expose()
    expiresIn = 3600;
    @Expose()
    applicationUser = "";
}

export class TokenSSO extends BaseModel {
    @Expose()
    accessToken = "";
    @Expose()
    applicationUser = "";
    @Expose()
    validUntil = 0;
}
